import { CircleLoader } from "../../components";

export const SentIcon = () => <CircleLoader />;
